module.exports = __webpack_public_path__ + "img/confirmation_icon.0d4bc165.svg";